module.exports = __webpack_public_path__ + "static/media/apply-for-incentives.f1ee7811.svg";